<new-ui-global-spinner />
<new-ui-global-confirmation />
<new-ui-global-toast />
<router-outlet />
